import { render } from "./Certification.vue?vue&type=template&id=1a77c56d&scoped=true"
import script from "./Certification.vue?vue&type=script&lang=js"
export * from "./Certification.vue?vue&type=script&lang=js"

import "./Certification.vue?vue&type=style&index=0&id=1a77c56d&lang=less&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a77c56d"]])

export default __exports__